import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoginServico } from '../servicos/login.servico';
import { UtilServico } from '../servicos/util.servico';
import { Router, ActivatedRoute } from '@angular/router';
import { Console } from '@angular/core/src/console';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { DatePipe, registerLocaleData } from '@angular/common';
import { NativeDateAdapter, NativeDateModule, DateAdapter } from '@angular/material';
import { CurrencyMaskModule } from "ngx-currency-mask";
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ngx-currency-mask/src/currency-mask.config";
import { FormControl, FormsModule, NgForm, FormBuilder, FormGroup, Validators, FormGroupDirective } from "@angular/forms";
import { ErrorStateMatcher } from '@angular/material/core';
import { ResponseContentType } from '@angular/http';
import { saveAs } from 'file-saver/FileSaver';
import { UtilDadosLogado } from '../servicos/util.logado';
import swal from 'sweetalert2';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: "."
};

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export function matchValidator(fieldName: string) {
  let fcfirst: FormControl;
  let fcSecond: FormControl;

  return function matchValidator(control: FormControl) {

    if (!control.parent) {
      return null;
    }

    // INITIALIZING THE VALIDATOR.
    if (!fcfirst) {
      //INITIALIZING FormControl first
      fcfirst = control;
      fcSecond = control.parent.get(fieldName) as FormControl;

      //FormControl Second
      if (!fcSecond) {
        throw new Error('matchValidator(): Second control is not found in the parent group!');
      }

      fcSecond.valueChanges.subscribe(() => {
        fcfirst.updateValueAndValidity();
      });
    }

    if (!fcSecond) {
      return null;
    }

    if (fcSecond.value !== fcfirst.value) {
      return {
        matchOther: true
      };
    }

    return null;
  }
}

export class MyDateAdapter extends NativeDateAdapter {

  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } else {
      return date.toDateString();
    }
  }
}
//declare var swal: any;
declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-inicial',
  templateUrl: './inicial.component.html',
  styleUrls: ['./inicial.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe, { provide: DateAdapter, useClass: MyDateAdapter }
    , { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }]
})
export class InicialComponent implements OnInit {
  userForm: FormGroup;
  password = 'password';
  display = 'none';
  //configuracoes: any;
  pesquisar: any;
  Placar: any;
  DADOS: any;
  DADOS2: any;
  SENHA: any;
  TotalRegistro: number;
  PaginaAtual: number = 1;
  PaginaTotal: number = 25;
  Mostrar: any;
  DADOSSIMULACAO: any;
  DADOSSIMULACAOESPONTANEA: any;
  DADOSPESSOAIS: any;
  DADOSRENDIMENTOS: any;
  EXPLICACAOREGRA: any;
  EXPLICACAOREGRAEXPONTANEA: any;
  ABONO_PERMANENCIA: any;
  public DADOCONTRIB: any;
  public DADOHOLERITE: any;
  public DADOSFICHA: any;
  public parametros: any;
  //public sub = "http://localhost:62195/api/Inicial/";
  //public sub = "http://localhost/webapiportales/api/Inicial/";  
  //public sub = "http://proxima.sisprevweb.com.br/webapiportales/api/Inicial/";
  //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipe/api/Inicial/";
  // public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipehomologacao/api/Inicial/";
  uf = [];
  cidades = [];
  segurados = [];
  nacionalidade = [];
  raca = [];
  FALE: any;
  
  public eleicoes   = [];
  public candidatos = [];
  public candidatosGeral = [];
  candidatoselecionado: Number;
  confirmarvoto: boolean;
  votou: boolean;
  fotoid: Number;
  Nomecandidato: string;
  public currenEleicaoIndex = 0;
  processandoEleicao = false;
  comprovanteNoFinal: boolean;
  comprovante: boolean;
  nomeEleicao: string;
  ehInativo: boolean;
  ehMilitar: boolean;
  ehEfetivo: boolean;
  jaRealizouRecad: boolean;

  assunto = [];
  public sexo: Array<Object> = [
    { ID: 'M', NOME: 'Masculino' },
    { ID: 'F', NOME: 'Feminino' }
  ];
  public molestia: Array<Object> = [
    { ID: 'S', NOME: 'Sim' },
    { ID: 'N', NOME: 'Não' }
  ];
  public estadocivil: Array<Object> = [
    { ID: 0, NOME: 'SOLTEIRO(A)' },
    { ID: 1, NOME: 'CASADO(A)' },
    { ID: 2, NOME: 'VIÚVO(A)' },
    { ID: 3, NOME: 'DIVORCIADO(A)' },
    { ID: 4, NOME: 'DESQUITADO(A)' },
    { ID: 5, NOME: 'AMASIADO(A)' },
    { ID: 6, NOME: 'OUTROS(A)' },
    { ID: 7, NOME: 'UNIÃO ESTÁVEL' },
    { ID: 8, NOME: 'SEPARADO JUDICIALMENTE' }
  ];
  public apos: Array<Object> = [
    { ID: 'S', NOME: 'Sim - Professor' },
    { ID: 'N', NOME: 'Não' }
  ];
  public mes: Array<Object> = [
    { ID: 1, NOME: 'Janeiro' },
    { ID: 2, NOME: 'Fevereiro' },
    { ID: 3, NOME: 'Março' },
    { ID: 4, NOME: 'Abril' },
    { ID: 5, NOME: 'Maio' },
    { ID: 6, NOME: 'Junho' },
    { ID: 7, NOME: 'Julho' },
    { ID: 8, NOME: 'Agosto' },
    { ID: 9, NOME: 'Setembro' },
    { ID: 10, NOME: 'Outubro' },
    { ID: 11, NOME: 'Novembro' },
    { ID: 12, NOME: 'Dezembro' },
  ];
  public logradouro: Array<Object> = [
    { ID: 8, NOME: 'Avenida' },
    { ID: 81, NOME: 'Rua' },
    { ID: 100, NOME: 'Travessa' },
    { ID: 77, NOME: 'Quadra' },
    { ID: 65, NOME: 'Praça' },
    { ID: 104, NOME: 'Vila' },
    { ID: 4, NOME: 'Alameda' },
    { ID: 31, NOME: 'Estrada' },
    { ID: 90, NOME: 'Rodovia' },
    { ID: 105, NOME: 'Assentamento' },
    { ID: 106, NOME: 'Condomínio' },
    { ID: 107, NOME: 'Conjunto' },
    { ID: 108, NOME: 'Distrito' },
    { ID: 109, NOME: 'Fazenda' },
    { ID: 110, NOME: 'Jardim' },
    { ID: 111, NOME: 'Loteamento' },
    { ID: 112, NOME: 'Parque' },
    { ID: 113, NOME: 'Povoado' },
    { ID: 114, NOME: 'Sítio' },
  ];
  selectedAssunto: any;
  selectedAssuntoId: any;
  public resultados = [];
  FormControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  matcher = new MyErrorStateMatcher();

  constructor(
    private fBuilder: FormBuilder,
    private http: Http,
    private LoginServico: LoginServico,
    private UtilServico: UtilServico,
    private router: Router,
    private datePipe: DatePipe,
    private dateAdapter: DateAdapter<MyDateAdapter>,
    private formBuilder: FormBuilder,
    public UtilDadosLogado: UtilDadosLogado
  ) {
    this.dateAdapter.setLocale('ptb');
  }

  ngOnInit() {
    this.UtilDadosLogado.DadosAcesso().DATA_ULTIMO_ACESSO = this.datePipe.transform(this.UtilDadosLogado.DadosAcesso().DATA_ULTIMO_ACESSO, 'dd/MM/yyyy HH:mm:ss')
    this.pesquisar = { PesquisarPor: 1, CadastroInLoco: "T", Concluido: "T", Categoria: 1 };
    this.DADOS = {};
    this.DADOS2 = {};
    this.DADOSSIMULACAO = { Codigo: 0 };
    this.DADOSSIMULACAOESPONTANEA = { Codigo: 0 };
    this.DADOCONTRIB = { MES_INICIO: new Date().getMonth() + 1, ANO_INICIO: new Date().getFullYear(), MES_FIM: new Date().getMonth() + 1, ANO_FIM: new Date().getFullYear() };
    this.SENHA = {};
    this.FALE = {};
    this.EXPLICACAOREGRA = {};
    this.DADOSPESSOAIS = {};
    this.parametros = {};
    this.DADOHOLERITE = { MES: new Date().getMonth() + 1, ANO: new Date().getFullYear() };
    this.DADOSFICHA = { ANO: new Date().getFullYear() };
    this.DADOSRENDIMENTOS = { ANO: new Date().getFullYear() - 1 };
    this.comprovante = false;
    this.jaRealizouRecad = false;
    this.GetSegurados();
    this.GetParametros();
    this.GetRecadastramento(false);
  }

  LimparEleicoes() : void {
    this.eleicoes   = [];
    this.candidatos = [];
    this.candidatosGeral = [];
    this.candidatoselecionado = 0;
    this.confirmarvoto = false;
    this.votou = false;
    this.fotoid = 0;
    this.Nomecandidato = '';
    this.currenEleicaoIndex = 0;
    this.processandoEleicao = false;
    this.comprovanteNoFinal = false;
    this.comprovante = false;
    this.nomeEleicao = '';
    this.ehInativo = false;
    this.ehMilitar = false;
    this.ehEfetivo = false;

  }

  //regioneleicoes
  GetEleicoes():void {  
    this.UtilServico.Get("GetEleicoes/"+this.UtilDadosLogado.DadosAcesso().PESSOA_ID).subscribe(
      data => {
        if (data.Eleicoes.length > 0 && data.Eleicoes[0].JA_VOTOU == "N")
        {
          this.eleicoes = data.Eleicoes;
          this.comprovanteNoFinal = this.eleicoes[0].COMPROVANTE == "S";
          this.GetCandidatos();
        } else
        {
          this.comprovante = data.Comprovante == "S";

          if (this.comprovante) {
            this.nomeEleicao = data.Eleicoes[0].TITULO;
            
            this.ehEfetivo = data.Eleicoes.filter((obj) => {
              return obj.CATEGORIA_ID === 1;
            }).length > 0;

            this.ehInativo = data.Eleicoes.filter((obj) => {
              return obj.CATEGORIA_ID === 2;
            }).length > 0;

            this.ehMilitar = data.Eleicoes.filter((obj) => {
              return obj.CATEGORIA_ID === 3;
            }).length > 0;

            if (this.parametros.PORTAL_ELEICAO == 'S') {
              swal.fire({
                title: 'Atenção',
                text: "Você já realizou a votação para a eleição de Conselho do Instituto de Previdência dos Servidores do Estado do Espírito Santo.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Comprovante',
                cancelButtonText: "Fechar!",
              }).then((result) => {
                if (result.value) {
                  this.EmitirComprovanteEleicao(0);
                }
              });
            }
          }
        }
      },
      error => { }
    );
  }

  SelecionarCandidato(indexCandidato: any) {
    for (let index = 0; index < this.candidatos.length; index++) {
      this.candidatos[index].SELECIONADO = 0;
    }

    this.candidatos[indexCandidato].SELECIONADO = 1;
    this.candidatos[indexCandidato].SEGURADO_ID = this.eleicoes[this.currenEleicaoIndex].SEGURADO_ID;
    this.candidatos[indexCandidato].PESSOA_ID = this.UtilDadosLogado.DadosAcesso().PESSOA_ID;
  }

  VotarNoCandidato() {
    var candidatoVotado = this.candidatos.filter((obj) => {
      return obj.SELECIONADO === 1;
    });

    if (candidatoVotado.length <= 0) {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "Selecione uma opção de voto!"
      });

      return;
    }
    
    for (let index = 0; index < candidatoVotado.length; index++)
    {
      for (let index_2 = 0; index_2 < this.candidatosGeral.length; index_2++)
      {
        if (candidatoVotado[index].CANDIDATO_ID == this.candidatosGeral[index_2].CANDIDATO_ID)
        {
          if (candidatoVotado[index].CATEGORIA_ID == this.candidatosGeral[index_2].CATEGORIA_ID)
          {
            if (candidatoVotado[index].CONSELHO_ID == this.candidatosGeral[index_2].CONSELHO_ID)
            {
              this.candidatosGeral[index_2].SELECIONADO = 1;
              this.candidatosGeral[index_2].SEGURADO_ID = this.eleicoes[this.currenEleicaoIndex].SEGURADO_ID;
              this.candidatosGeral[index_2].PESSOA_ID = this.UtilDadosLogado.DadosAcesso().PESSOA_ID;
            }
          }
        }
      }
    }

    this.currenEleicaoIndex += (this.currenEleicaoIndex + 1 == this.eleicoes.length) ? 0 : 1;
    this.candidatos = this.candidatosGeral.filter((obj) => {
      return obj.ELEICAO_ID === this.eleicoes[this.currenEleicaoIndex].ELEICAO_ID &&
             obj.CATEGORIA_ID === this.eleicoes[this.currenEleicaoIndex].CATEGORIA_ID &&
             obj.CONSELHO_ID === this.eleicoes[this.currenEleicaoIndex].CONSELHO_ID;
    });

    if (this.currenEleicaoIndex + 1 == this.eleicoes.length) {
      this.confirmarvoto = true;
    } else {
      this.confirmarvoto = false;
    }
  }

  VoltarEleicao() {
    this.currenEleicaoIndex -= 1;
    this.candidatos = this.candidatosGeral.filter((obj) => {
      return obj.ELEICAO_ID === this.eleicoes[this.currenEleicaoIndex].ELEICAO_ID &&
             obj.CATEGORIA_ID === this.eleicoes[this.currenEleicaoIndex].CATEGORIA_ID &&
             obj.CONSELHO_ID === this.eleicoes[this.currenEleicaoIndex].CONSELHO_ID;
    });
    this.confirmarvoto = false;
  }

  ConfirmarVoto() {
    this.Mostrar = true;

    var candidatosVotado = this.candidatosGeral.filter((obj) => {
      return obj.SELECIONADO === 1;
    });

    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/PostVotoEleicao", JSON.stringify({parametroVoto: candidatosVotado, USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID}), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.processandoEleicao = false;

          if (data.Status == 1) {
            this.votou = true;
          } else {
            swal.fire({
              title: "Erro!",
              type: "error",
              text: data.Message
            });
          }
      },
      error => {
        this.Mostrar = false;
        this.processandoEleicao = false;

        swal.fire({
          title: "Erro!",
          type: "error",
          text: "Não foi possível realizar o voto!"
        });
      }
    );
  }

  GetCandidatos():void {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetCandidatos", JSON.stringify({ELEICAO_ID: this.eleicoes[this.currenEleicaoIndex].ELEICAO_ID, CATEGORIA_ID: this.eleicoes[this.currenEleicaoIndex].CATEGORIA_ID, CONSELHO_ID: this.eleicoes[this.currenEleicaoIndex].CONSELHO_ID}), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.candidatosGeral = data;
          
          for (var index = 0; index < 2; index++) {
            for (var index_2 = 1; index_2 <= 3; index_2++) {
              this.candidatosGeral.push({
                CANDIDATO_ID: 0,
                ELEICAO_ID: this.eleicoes[this.currenEleicaoIndex].ELEICAO_ID,
                CONSELHO_ID: index,
                CATEGORIA_ID: index_2,
                NOME: "VOTO EM BRANCO",
                APELIDO: "",
                SELECIONADO: 0,
                PESSOA_ID: 0
              });
            }
          }
          
          this.candidatos = data.filter((obj) => {
            return obj.ELEICAO_ID === this.eleicoes[this.currenEleicaoIndex].ELEICAO_ID &&
                   obj.CATEGORIA_ID === this.eleicoes[this.currenEleicaoIndex].CATEGORIA_ID &&
                   obj.CONSELHO_ID === this.eleicoes[this.currenEleicaoIndex].CONSELHO_ID;
          });
      },
      error => { }
    );
  }

  EmitirComprovanteEleicao(categoriaId: number) {
    this.Mostrar = true;
    
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    
    options.responseType = ResponseContentType.Blob;
    
    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetComprovante", JSON.stringify({PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID, CATEGORIA_ID: categoriaId}), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          
          window.open(fileURL);
        },
        error => {
          this.Mostrar = false;
          
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Não foi possível gerar o comprovante!"
          });
        }
      );
  }
  //endregioneleicoes

  CarregarGridInicial(currentPage: number) {
    this.Mostrar = true;

    this.UtilServico.Post("GetProcesso", JSON.stringify({ SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.resultados = data.Resultado;
          if (this.TotalRegistro == 0) {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: "Nenhum processo encontrado"
            });
          }
        },
        error => {

        }
      );
  }

  public pageChanged(event: any): void {
    this.PaginaAtual = event;
    this.CarregarGridInicial(event);
  }

  public EditarClick() {
    this.CarregarGridInicial(1);
  }

  //#region simulacao
  public Simulacao() {
    this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.Mostrar = true;
    this.DADOSSIMULACAO.Codigo = 0;
    this.UtilServico.Post("GetSimulacao", JSON.stringify({
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID, MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG, CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
      DATA_CALC: this.DADOS2.DATA_CALC
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.DADOS2 = data.Resultado[0];
          this.DADOS = this.DADOS2.Table[0];
          this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
          this.DADOS.DATA_ADM = this.datePipe.transform(this.DADOS.DATA_ADM, 'dd/MM/yyyy');
          this.DADOS.DATA_NASC = this.datePipe.transform(this.DADOS.DATA_NASC, 'dd/MM/yyyy');
        },
        error => {

        }
      );
  }

  public SimularSegurado(event: any) {
    this.ABONO_PERMANENCIA = "N";
    this.Mostrar = true;
    this.UtilServico.Post("SimularSegurado", JSON.stringify({ SEGURADO_ID: event, DATA_CALC: this.DADOS2.DATA_CALC, DATA_NASC: this.DADOS.DATA_NASC, IDADE: this.DADOS.IDADE, ABONO_PERMANENCIA: "N" }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSSIMULACAO = data;
          if (data.Codigo == 0) {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: data.Msg
            });
          }
          else {
            this.DADOSSIMULACAO.Codigo = 1;
            this.TotalRegistro = data.Total;
            this.resultados = data.Resultado;
          }
        },
        error => {

        }
      );
  }
  public ResultadoSimulacao(event: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetResultadoSimulacao", JSON.stringify({ RESULTADO_SIMULACAO_ID: event.RESULTADO_SIMULACAO_ID, SIMULA_REQUISITO_ID: event.SIMULA_REQUISITO_ID, TmpCarreira: event.TmpCarreira, SIMULA_ABONO: this.ABONO_PERMANENCIA }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ResultadoSimulacao.pdf");
        },
        error => {
          this.Mostrar = false;
        }
      );
  }
  public ExplicacaoRegra(event: any) {
    this.EXPLICACAOREGRA = event;
    $("#ModalSimulacaoExplicao").show();
    $("#ModalSimulacao").hide();
  }
  public SairExplicacaoRegra() {
    $("#ModalSimulacaoExplicao").hide();
    $("#ModalSimulacao").show();
  }
  public SimularSeguradoAbono(event: any) {
    this.ABONO_PERMANENCIA = "S";
    this.Mostrar = true;
    this.UtilServico.Post("SimularSegurado", JSON.stringify({ SEGURADO_ID: event, DATA_CALC: this.DADOS2.DATA_CALC, DATA_NASC: this.DADOS.DATA_NASC, IDADE: this.DADOS.IDADE, ABONO_PERMANENCIA: "S" }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSSIMULACAO = data;
          if (data.Codigo == 0) {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: data.Msg
            });
          }
          else {
            this.DADOSSIMULACAO.Codigo = 1;
            this.TotalRegistro = data.Total;
            this.resultados = data.Resultado;
          }
        },
        error => {

        }
      );
  }
  //#endregion simulacao

  //#region simulacaoespontanea
  public ExplicacaoRegraExpontanea(event: any) {
    this.EXPLICACAOREGRAEXPONTANEA = event;
    $("#ModalSimulacaoExplicaoExpontanea").show();
    $("#ModalSimulacaoEspontanea").hide();
  }
  public SairExplicacaoRegraExpontanea() {
    $("#ModalSimulacaoExplicaoExpontanea").hide();
    $("#ModalSimulacaoEspontanea").show();
  }
  public SimulacaoEspontanea() {
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.Mostrar = true;
    this.UtilServico.Post("GetSimulacaoEspontanea", JSON.stringify({
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID, MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG, CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
      DATA_CALC: this.DADOS2.DATA_CALC
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.DADOS2 = data.Resultado[0];
          this.DADOS = this.DADOS2.Table[0];
          this.DADOS.DATA_ADM = this.datePipe.transform(this.DADOS.DATA_ADM, 'dd/MM/yyyy');
          this.DADOS.DATA_NASC = this.datePipe.transform(this.DADOS.DATA_NASC, 'dd/MM/yyyy');
          this.DADOS.ESPECIAL = "N";
          this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
          this.DADOS.DATA_CALC = this.DADOS2.DATA_CALC;
        },
        error => {

        }
      );
  }
  public SimularEspontanea(event: any) {

    this.Mostrar = true;
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.UtilServico.Post("GetGerarSimulacaoEspontanea", JSON.stringify({
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID, MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG, CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
      DATA_CALC: this.DADOS2.DATA_CALC, DATA_ADM: this.DADOS.DATA_ADM
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSSIMULACAOESPONTANEA = data;
          if (data.Codigo == 0) {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: data.Msg
            });

          }
          else {
            this.DADOSSIMULACAOESPONTANEA.Codigo = 1;
            this.TotalRegistro = data.Total;
            this.resultados = data.Resultado;
          }
        },
        error => {
          this.Mostrar = false;
        }
      )
  }

  //#endregion simulacaoespontanea 

  public Processos(event: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetHistorico", JSON.stringify({ PROCESSO_ID: event }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "HistoricoProcesso.pdf");
        },
        error => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }

  AlterSenha() {
    this.Mostrar = true;
    if (this.SENHA.NOVA !== this.SENHA.CONFIRMA) {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!"
      });
    }
    else {
      this.UtilServico.Post("GetTrocarSenha", JSON.stringify({ ATUAL: this.SENHA.ATUAL, NOVA: this.SENHA.NOVA, LOGIN: this.UtilDadosLogado.DadosAcesso().LOGIN, USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID }))
        .subscribe(
          data => {
            this.Mostrar = false;
            this.TotalRegistro = data.Total;
            if (this.TotalRegistro == 0) {
              swal.fire({
                title: "Atenção!",
                type: "error",
                text: "Senha atual não confere!"
              });
            }
            else {
              swal.fire({
                title: "Atenção!",
                type: "success",
                text: "Senha alterada com sucesso!"
              });
              $("#ModalTrocarSenha").hide();
              $(document.body).removeClass("modal-open");
              $(".modal-backdrop").remove();
            }
          },
          error => {
            this.Mostrar = false;
          }
        );
    }

  }

  //#region faleconosco
  Assunto() {
    if (this.UtilDadosLogado.DadosAcesso().FONE_RESIDENCIAL != null)
      this.FALE.FONE_RESIDENCIAL = this.UtilDadosLogado.DadosAcesso().FONE_RESIDENCIAL;
    if (this.UtilDadosLogado.DadosAcesso().EMAIL1 != null)
      this.FALE.EMAIL1 = this.UtilDadosLogado.DadosAcesso().EMAIL1;
    this.UtilServico.Get("GetAssunto").subscribe(data => this.assunto = data, error => { });
  }
  setAssunto($event) {
    this.selectedAssuntoId = $event;
    for (var i = 0; i < this.assunto.length; i++) {
      if (this.assunto[i].ASSUNTO_ID == $event) {
        this.selectedAssunto = this.assunto[i].NOME;
      }
    }
  }

  FaleConosco() {
    this.Mostrar = true;
    this.UtilServico.Post("GetFaleConosco", JSON.stringify({
      ASSUNTO_ID: this.selectedAssuntoId, ASSUNTO_NOME: this.selectedAssunto, EMAIL1: this.FALE.EMAIL1,
      FONE_RESIDENCIAL: this.FALE.FONE_RESIDENCIAL, DSC_ASSUNTO: this.FALE.DSC_ASSUNTO, NOME: this.UtilDadosLogado.DadosAcesso().NOME,
      USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID, SEXO: this.UtilDadosLogado.DadosAcesso().SEXO
    }))
      .subscribe(
        data => {
          this.TotalRegistro = data.Total;
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "success",
            text: "Email encaminhado com sucesso!"
          });
        },
        error => {
          this.Mostrar = false;
        }
      );
  }
  //#endregion faleconosco

  //#region dadospessoais
  GetUf() {
    this.UtilServico.Get("GetUf").subscribe(
      data => {
        this.uf = data;
      },
      error => { }

    );
  }
  GetCidades(uf: string) {
    this.UtilServico.Get("GetCidades/" + uf).subscribe(
      data => this.cidades = data,
      error => { }
    );
  }
  GetSegurados() {
    this.UtilServico.Get("GetSegurados/" + this.UtilDadosLogado.DadosAcesso().PESSOA_ID)
      .subscribe(
        data => {
          this.segurados = data;
        },
        error => {
        }
      );
  }
  GetRecadastramento(ehInfo : boolean) {
    this.UtilServico.Get("GetRecadastramento/" + this.UtilDadosLogado.DadosAcesso().SEGURADO_ID)
      .subscribe(
        data => {
          // console.log(this.UtilDadosLogado.DadosAcesso());
            if (data[0].RecadPortal == "S") {
                this.jaRealizouRecad = true;
            swal.fire({
              title: 'Atenção',
              text: "Você já realizou a atualização dos seus dados, em breve a equipe do IPAJM validará estas informações!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Protocolo',
              cancelButtonText: "Fechar!",
            }).then((result) => {
              //if (!ehInfo)
                this.GetEleicoes();
              console.log(result.value);
              if (result.value) {
                this.EmitirProtocoloRecadastramento();
              }
            });
          } else {
            this.jaRealizouRecad = false;
            //if (!ehInfo)
                this.GetEleicoes();
          }
        },
        error => {
          //if(!ehInfo)
            this.GetEleicoes();
        }
      );
  }
  EmitirProtocoloRecadastramento() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    console.log(this.UtilDadosLogado.DadosAcesso().SEGURADO_ID);
    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/ImprimirProtocolo", JSON.stringify({
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID, PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            saveAs(file, "ProtocoloRecadastramento.pdf");
          }
          else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }

          //saveAs(file, "ComprovanteRendimentosPagos.pdf");
        },
        error => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  GetSeguradoInfo(event) {
    this.Mostrar = true;
    this.UtilServico.Get("GetSeguradoInfo/" + event).subscribe(
      data => {
        console.log(data);
        localStorage.setItem('AcessoAdm', JSON.stringify(Object.assign(data, { URL: this.UtilDadosLogado.DadosAcesso().URL, TOKEN: this.UtilDadosLogado.DadosAcesso().TOKEN, RECADASTRAMENTO_LINK: this.UtilDadosLogado.DadosAcesso().RECADASTRAMENTO_LINK })));
        //this.UtilDadosLogado.DadosAcesso() = data;
        this.Mostrar = false;
        this.LimparEleicoes();
        this.GetRecadastramento(true);
      },
      error => { this.Mostrar = false; }
    );
  }
  GetNacionalidade() {
    this.UtilServico.Get("GetNacionalidade").subscribe(
      data => {
        this.nacionalidade = data;
      },
      error => { }

    );
  }
  GetRaca() {
    this.UtilServico.Get("GetRaca").subscribe(
      data => {
        this.raca = data;
      },
      error => { }

    );
  }

  Pessoas() {
    this.GetUf();
    this.GetNacionalidade();
    this.GetRaca();
    this.Mostrar = true;
    this.UtilServico.Post("GetPessoas", JSON.stringify({
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSPESSOAIS = data.Resultado;
          this.DADOSPESSOAIS.DATA_NASC = this.datePipe.transform(this.DADOSPESSOAIS.DATA_NASC, 'dd/MM/yyyy');
          this.DADOSPESSOAIS.RG_DT_EMISSAO = this.datePipe.transform(this.DADOSPESSOAIS.RG_DT_EMISSAO, 'dd/MM/yyyy');
          this.DADOSPESSOAIS.CTPS_DT_EMISSAO = this.datePipe.transform(this.DADOSPESSOAIS.CTPS_DT_EMISSAO, 'dd/MM/yyyy');
          if (this.DADOSPESSOAIS.UfNascimento != null)
            this.GetCidades(this.DADOSPESSOAIS.UfNascimento);
          if (this.DADOSPESSOAIS.NACIONALIDADE_ID == null)
            this.DADOSPESSOAIS.NACIONALIDADE_ID = 25;
        },
        error => {
          this.Mostrar = false;
        }
      );
  }
  public SalvarPessoas() {
    this.Mostrar = true;

    if (this.parametros.PORTAL_CADASTRO_DIRETO === "S") {
      this.UtilServico.Put('PutPESSOAS/' + this.DADOSPESSOAIS.PESSOA_ID, this.DADOSPESSOAIS)
        .subscribe(
          data => {
            swal.fire({
              title: "Atenção!",
              type: "success",
              text: "Cadastro atualizado com sucesso!"
            });
          },
          error => {
            swal.fire({
              title: "Atenção!",
              type: "warning",
              text: "Ocorreu um erro ao atualizar os dados, entre em contato com o suporte!"
            });
          }
        )
        .add(() => this.Mostrar = false);;
    } else {
      this.UtilServico.Post('PostPESSOAS_TMP', this.DADOSPESSOAIS)
        .subscribe(
          data => {
            swal.fire({
              title: "Sucesso!",
              type: "success",
              text: "Atualização enviada para aprovação!"
            });
          },
          error => {
            swal.fire({
              title: "Atenção!",
              type: "warning",
              text: "Ocorreu um erro ao atualizar os dados, entre em contato com o suporte!"
            });
          }
        )
        .add(() => this.Mostrar = false);
    }

  }
  //#endregion dadospessoais

  //region extratocontrib
  public EmitirExtrato() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetExtratoContrib", JSON.stringify({
      MES_INICIO: this.DADOCONTRIB.MES_INICIO, ANO_INICIO: this.DADOCONTRIB.ANO_INICIO,
      MES_FIM: this.DADOCONTRIB.MES_FIM, ANO_FIM: this.DADOCONTRIB.ANO_FIM, PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID, MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG, CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ExtratoContribuicao.pdf");
        },
        error => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion extratocontrib

  //#region holerite
  public EmitirHolerite() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetHolerite", JSON.stringify({
      MES_INICIO: this.DADOHOLERITE.MES, ANO_INICIO: this.DADOHOLERITE.ANO,
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID, DECIMO: this.DADOHOLERITE.DECIMO,
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID, MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG, CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "Holerite.pdf");
        },
        error => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion holerite

  //#region fichafinanceira
  public EmitirFichaFinanceira() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetFichaFinanceira", JSON.stringify({
      ANO_INICIO: this.DADOSFICHA.ANO,
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID, MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG, CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "FichaFinanceira.pdf");
        },
        error => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion fichafinanceira

  //region rendimentospagos
  public EmitirComprovanteRendimentos() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/ComprovanteRendimentos", JSON.stringify({
      ANO_INICIO: this.DADOSRENDIMENTOS.ANO,
      PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID, USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID, MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG, CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ComprovanteRendimentosPagos.pdf");
        },
        error => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion rendimentospados 
  
  //region parametros
  GetParametros(): void {
    this.UtilServico.Get("GetParametros/").subscribe(
      data => {
        this.parametros = data[0];
      },
      error => { }
    );
  }
  //#endregion parametros
  Recadastramento() {
    localStorage.setItem('AcessoCenso', JSON.stringify(Object.assign(this.UtilDadosLogado.DadosAcesso(), { Parametro: this.parametros.PORTAL_CADASTRO_DIRETO })));
    
    let link = this.UtilDadosLogado.DadosAcesso().RECADASTRAMENTO_LINK;

    if (!link) {
      return;
    }

    if (link.includes("PESSOA_ID=")) {
      link = link.replace("PESSOA_ID=", `PESSOA_ID=${this.UtilDadosLogado.DadosAcesso().PESSOA_ID}`);
    }

    window.open(link,"_blank");
  }

  logout() {
    localStorage.removeItem('AcessoAdm');
    this.router.navigate(['/login']);
  }

  //#region Recadastramento
}



// WEBPACK FOOTER //
// D:/Agents/es/_work/11/s/ANGULAR/src/app/inicial/inicial.component.ts